module.exports = __webpack_public_path__ + "img/KSC03800.134b7260.jpg";